/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.5.0-nightly.2026.8.2",
    versionName: "0.5.0-nightly.2026.8.2",
    versionChannel: "nightly",
    buildDate: "2026-08-02T00:29:03.071Z",
    commitHash: "402372d96685c33becc854041c49d35c2609f16d",
};
